import { useState } from "react";
import { Button, Input } from "@vimos/ui";
import { supabase } from "../lib/supabase";

export function LoginPage() {
  const [status, setStatus] = useState<"idle" | "loading" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState("");

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setStatus("loading");
    const { error } = await supabase.auth.signInWithPassword({
      email: String(form.get("email") ?? ""),
      password: String(form.get("password") ?? ""),
    });
    if (error) {
      setStatus("error");
      setErrorMessage(
        error.message === "Invalid login credentials"
          ? "Correo o contraseña incorrectos."
          : "No pudimos iniciar sesión. Intenta de nuevo.",
      );
      return;
    }
    setStatus("idle");
  }

  return (
    <div className="bg-paper flex min-h-screen items-center justify-center px-4">
      <div className="border-sand/40 bg-paper shadow-card w-full max-w-sm rounded-lg border p-8">
        <h1 className="font-display text-ink text-2xl font-bold">Vimos Admin</h1>
        <p className="text-mist mt-1 text-sm">Inicia sesión para gestionar el contenido.</p>

        <form onSubmit={handleSubmit} className="mt-6 flex flex-col gap-4">
          <Input name="email" type="email" label="Correo" required autoComplete="email" />
          <Input
            name="password"
            type="password"
            label="Contraseña"
            required
            autoComplete="current-password"
          />
          {status === "error" && (
            <p role="alert" className="text-sm text-red-600">
              {errorMessage}
            </p>
          )}
          <Button type="submit" isLoading={status === "loading"}>
            Iniciar sesión
          </Button>
        </form>
      </div>
    </div>
  );
}
